const es = {
  table: {
    actions: "Acciones",
  },
  errors: {
    requiredFieldsEmpty: "Hay campos obligatorios vacíos",
    fieldRequired: "Se requiere campo",
  },
  print: "impresión",
  login: "Acceso",
  username: "Nombre de usuario",
  password: "Contraseña",
  customFields: "Campos Personalizados",
  variables: "Variables",
  edit: "Editar",
  general: "General",
  delete: "Eliminar",
  save: "Salvar",
  confirm: "Confirmar",
  warning: "Atencion",
  cancel: "Cancelar",
  hours: "Horas",
  minutes: "Minutos",
  logout: "Salir",
  options: "Opciones",
  height: "Altura",
  titleModalConfigFields: "Configuración de campo",
  titleModalConfigFieldsColumnOne: "Campos de trabajo",
  titleModalConfigFieldsColumnTwo: "Campos de tipo de registro seleccionados",
  dayOfWeek: {
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miercoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sabado",
  },
  analyzeInput: { title: "Análisis", group: "Grupo | Grupos" },
  components: {
    basicHistory: {
      createAt: "Incluido en",
      createBy: "por",
    },
    regEdit: {
      filters: {
        jobCode: "Código Job",
        resourceCode: "Código recursos",
        regTypeCode: "Código tipo de registro",
        user: "Usuario",
        dtStart: "Fecha de inicio",
        dtEnd: "Fecha de finalización",
        searchEdit: "Buscar",
      },
      headers: {
        date: "Fecha",
        job: "Trabajo",
        resource: "Recurso",
        user: "Usuario",
        regType: "Tipo de Registro",
        description: "Descripción",
        codAccount: "Código de cuenta",
        desAccount: "Descripción de cuenta",
        codItem: "Código del objeto",
        descItem: "Descripción del Artículo",
        isIntegrated: "Integrado",
      },
      fields: {
        fieldTitle: "Campos",
        fieldDelete: "Eliminar",
        fieldSubtitle: "Campo",
        valueSubtitle: "Valor",
        noFields: "Sin Campo",
      },
    },
  },
  entities: {
    reg: {
      title: "Registro | Registros",
      production: "Producción",
      props: {
        date: "Data | Data Retroactivo"
      }
    },
    actionField: {
      title: "Campo | Campos",
      comboValue: "Valor",
      props: {
        label: "Etiqueta",
        dataType: "Tipo de datos",
        isRequired: "Necesario",
        combo: "Combo",
      },
    },
    action: {
      title: "Acción | Acciónes",
      props: {
        code: "Código",
        description: "Descripción",
        path: "Camino",
        type: "Tipo",
        group: "Grupo",
        entity: "Entidad",
        response: "Respuesta",
        fields: "Campos"
      },
    },
    job: {
      title: "Job | Jobs",
      solic: "Solicitud de Job",
      props: {
        code: "Código",
        group: "¿Es el grupo Job?",
        description: "Descripción",
        status: "Estado",
        date: "Fecha",
        environmentId: "Ambiente",
        item: "Articulo",
        qt: "Cantidad",
        version: "Versión",
        accountId: "Cuenta",
        deadline: "Deadline",
        notes: "Observacion"
      },
      forms: {
        create: {
          title: "Crear job",
        },
      },
    },
    jobStageItemCons: {
      title: "Artículo | Artículos",
      props: {
        itemId: "Artículo registrado",
        itemDescription: "Descripción del artículo",
        unitId: "Unidad",
        qtEstimated: "Cantidad estimada",
        qtReal: "Cantidad real",
      },
    },
    jobStageItemProd: {
      title: "Artículo | Artículos",
      props: {
        itemId: "Artículo registrado",
        itemDescription: "Descripción del artículo",
        unitId: "Unidad",
        qtEstimated: "Cantidad estimada",
        qtReal: "Cantidad real",
      },
    },
    printer: {
      title: "Impresora | Impresoras",
      props: {
        code: "Código",
        description: "Descripción",
        path: "Camino",
        printAgentPath: "Camino Print Agent ",
      },
    },
    jobStage: {
      title: "Jog Stage | Prácticas laborales",
      tabs: {
        form: {
          jobStageItemsProd: "Artículos Prod",
          jobStageItemsCons: "Artículos Contras",
        },
      },
      props: {
        status: "Estado",
        order: "Orden",
        description: "Descripción",
        timeSetupEstimatedMin: "Configuración estimada (min)",
        timeSetupRealMin: "Configuración Real (Min)",
        timeProdEstimatedMin: "Producción estimada (min)",
        timeProdRealMin: "Producción real (min)",
        qtLossEstimated: "Cantidad de pérdida estimada",
        qtLossReal: "Cantidad de pérdida real",
        percLoss: "% De pérdida estimada",
        resourceId: "Recurso",
        stageTypeId: "Tipo de pasantía",
        versionId: "Versão",
        itemId: "Item",
        subStage: "Sub-estágio",
      },
    },
    stageType: {
      title: "Tipo de pasantía | Tipos de pasantías",
      tabs: {
        form: {
          regTypes: "Tipos de Registro",
        },
      },
      props: {
        description: "Descripción",
        name: "Nombre",
        environmentId: "Ambiente",
      },
    },
    user: {
      title: "Usuario | Los usuarios",
      props: {
        code: "Código",
        name: "Nombre",
      },
    },
    report: {
      title: "Reporte | Reportes",
      props: {
        query: "Query",
        font: "Hacen",
        params: "Parámetro | Parámetros",
        description: "Descripción",
      },
    },
    resource: {
      title: "Recurso | Recursos",
      props: {
        code: "Código",
        seq: "Seq",
        environmentId: "Ambiente",
        description: "Descripción",
        stageTypeId: "Tipo de pasantía",
        printerId: "Impresora",
        resourceRestIds: "Característica compatible",
        sector: "Sector",
        type: "Tipo",
      },
    },
    entityFieldCustom: {
      title: 'Campo Personalizado | Campos Personalizados',
      props: {
        entity: 'Entidad',
        type: 'Tipo',
        group: 'Grupo',
        label: 'Etiqueta',
        seq: "Seq"
      }
    },
    account: {
      title: "Cuenta | Cuentas",
      props: {
        code: "Código",
        name: "Nombre",
      },
    },
    regTypeFields: {
      title: "Campo de Registro | Campos de Registro",
      props: {
        label: "Campo",
        seq: "Seq",
        typeData: "Tipo de Dado",
        behavior: "Comportamiento",
        parameterItemId: "Artículo parámetro",
        length: "Límite de caracteres",
        required: "Requerido",
        optionLabel: "Opcion",
        readOnly: "Solo lectura",
        variableKey: "Nombre Variable",
        readType: "Tipo de lectura"
      },
    },
    regType: {
      title: "Tipo de Registro | Tipos de Registro",

      props: {
        code: "Código",
        description: "Descripción",
        keepFieldIds: "Mantener los campos",
        continuous: "Continuo",
        allowRetroactive: "Permitir retroactivo",
        retroactiveLimitDays: "Días de límite retroactivo",
        color: "Color",
        stageRequired: "Requiere pasantía",
        environmentId: "Ambiente",
        jobStatusId: "Cambiar al estado del job",
        jobStageStatusId: "Cambiar al estado de la etapa de job",
        reportId: "Reporte",
        printerId: "Impresora",
        timeType: 'Hora',
        trigger: {
          title: 'Desencadenar | Disparadores',
          props: {
            confirm: 'Confirmar',
            beforeSend: 'Después de enviar',
            afterSend: 'Antes de Enviar'
          }
        },
      },
    },
    regEdit: {
      title: "Consulta del registro  | Consulta del registros ",
    },
    environment: {
      filter: "Sector",
      title: "Ambiente | Ambientes",
      calendarExc: {
        title: "Calendario Exc",
        props: {
          date: "Datos",
          start: "Hora de inicio",
          end: "Hora Final",
        },
      },
      calendarProd: {
        title: "Calendario de productos",
        props: {
          dayOfWeek: "Dia de la semana",
          start: "Hora de inicio",
          end: "Hora Final",
        },
      },
      jobStageStatus: {
        title: "Estado de la etapa del job",
        props: {
          status: "Estado",
          seq: "Seq",
          description: "Descripción",
          color: "Color",
          statusNext: "Siguiente estado",
          type: "Tipo",
        },
      },
      jobStatus: {
        title: "Estado del job",
        props: {
          status: "Estado",
          seq: "Seq",
          description: "Descripción",
          color: "Color",
          statusNext: "Siguiente estado",
          leadTimeMin: "Plazo de entrega (min)",
        },
      },
      tabs: {
        form: {
          jobStatus: "Estado del job",
          jobStageStatus: "Estado de la etapa del job",
          calendarProd: "Calendario de productos",
          calendarExc: "Calendario Exc",
        },
      },
      props: {
        code: "Código",
        description: "Descripción",
      },
    },
    stageItem: {
      title: "Artículo | Artículos",
      itemDatabase: "Artículo existente",
      props: {
        itemId: "Articulo registrado",
        itemDescription: "Descripción del artículo",
        unitId: "Unidad",
        qt: "Cantidad:",
        qtMin: "Cantidad Min",
        qtMax: "Cantidad Max",
        qtIdeal: "Cantidad ideal",
      },
    },
    stage: {
      title: "Pasantía | Pasantías",
      tabs: {
        form: {
          stageItemsProd: "Artículos de productos",
          stageItemsCons: "Artículos en contra",
        },
      },
      props: {
        description: "Descripción",
        seq: "Cadena",
        timeSetupEstimatedMin: "Configuración estimada (min)",
        timeProdEstimatedMin: "Producción estimada (min)",
        percLoss: "% De pérdida estimada",
        resourceId: "Recurso",
        stageTypeId: "Tipo de pasantía",
        versionId: "Versão",
        itemId: "Item",
        subStage: "Sub-estágio",
      },
    },
    version: {
      title: "Version | Versiones",
      tabs: {
        form: {
          stages: "Pasantías",
        },
      },
      props: {
        code: "Código",
        description: "Descripción",
        unit: "Unidad",
      },
    },
    item: {
      title: "Artículo | Artículos",
      props: {
        code: "Código",
        environmentId: "Ambiente",
        description: "Descripción",
        unit: "Unidad",
        type: "Tipo",
      },
    },
    unit: {
      title: "Unidad | Unidades",
      props: {
        code: "Código",
        description: "Descripción",
        type: "Tipo",
      },
    },
  },
};

export default es;
